import postEffectsMap from "./post-effects-map";
import {PhotolabTaskBuilder} from "@vicman-wi/photolab-api-js";
import {arrayRandom} from "@vicman-wi/utils-js/esm/array/random";

/**
 * @param {import("@vicman-wi/photolab-api-js").PhotolabApi} photolabApi
 * @param {string[]} postEffects
 * @param {string} imageUrl
 * @return {Promise<{effect: string, taskResult: import("@vicman-wi/photolab-api-js").PhotolabTaskResult}>}
 */
export async function applyPostEffect(photolabApi, postEffects, imageUrl) {
  if (!Array.isArray(postEffects) || postEffects.length === 0) {
    return undefined;
  }

  for (let i = 0; i < postEffects.length; i++) {
    const postEffect = postEffects[i];
    if (!postEffectsMap[postEffect]) {
      continue;
    }

    const taskResult = await photolabApi.task(new PhotolabTaskBuilder()
      .addCollageMethod({ template_name: arrayRandom(postEffectsMap[postEffect]) })
      .addImage(imageUrl)
      .build());

    return {
      effect: postEffect,
      taskResult,
    };
  }

  return undefined;
}
